"use client";

import { c as _c } from "react/compiler-runtime";
import { useAbility } from "@/hooks/useAbility";
import { useOrgSettingsAccess } from "@/hooks/useOrgSettingsAccess";
import { useTeamSettingsAccess } from "@/hooks/useTeamSettingsAccess";
import { useTeamsContext } from "@/hooks/useTeamsContext";
export type SettingsEntry = {
  kind: "org";
  href: string;
} | {
  kind: "team";
  href: string;
} | null;

/** The single settings destination a person gets: org settings win, then the current team, then nothing. */
export function useSettingsEntry(organizationScopeId) {
  const $ = _c(4);
  const {
    isLoading
  } = useAbility();
  const {
    currentScopeId
  } = useTeamsContext();
  const {
    hasAnyAccess: hasOrgAccess,
    firstAccessiblePath: orgPath
  } = useOrgSettingsAccess(organizationScopeId);
  const {
    hasAnyAccess: hasTeamAccess,
    firstAccessiblePath: teamPath
  } = useTeamSettingsAccess(currentScopeId || undefined);
  if (isLoading) {
    return null;
  }
  if (hasOrgAccess && orgPath) {
    let t0;
    if ($[0] !== orgPath) {
      t0 = {
        kind: "org",
        href: orgPath
      };
      $[0] = orgPath;
      $[1] = t0;
    } else {
      t0 = $[1];
    }
    return t0;
  }
  if (currentScopeId && hasTeamAccess && teamPath) {
    const t0 = `${teamPath}?scopeId=${currentScopeId}&scopeType=TEAM`;
    let t1;
    if ($[2] !== t0) {
      t1 = {
        kind: "team",
        href: t0
      };
      $[2] = t0;
      $[3] = t1;
    } else {
      t1 = $[3];
    }
    return t1;
  }
  return null;
}